import PageContentEditor from "./PageContentEditor";

export function AdminAboutPage() {
  return (
    <PageContentEditor
      pageKey="about_page"
      title="About Page Content"
      schema={[
        {
          key: "hero", title: "Hero", hint: "First view of the About page.",
          fields: [
            { key: "overline", label: "Overline (red caption above headline)", placeholder: "About Durga Auto Industries" },
            { key: "headline", label: "Headline — Line 1" },
            { key: "headline_accent", label: "Headline — Line 2 (red accent)" },
            { key: "subtitle", label: "Subtitle paragraph", type: "textarea" },
            { key: "image", label: "Hero background image URL (optional — defaults to Hero Slide 1)", placeholder: "https://… or leave empty" },
            { key: "cta_primary_text", label: "Primary CTA Text" },
            { key: "cta_primary_link", label: "Primary CTA Link" },
            { key: "cta_secondary_text", label: "Secondary CTA Text" },
            { key: "cta_secondary_link", label: "Secondary CTA Link" },
          ],
        },
        {
          key: "founder_quote", title: "Founder's Quote Card", hint: "The red quote card next to the hero.",
          fields: [
            { key: "enabled", label: "Show founder quote card", type: "boolean" },
            { key: "text", label: "Quote text", type: "textarea" },
            { key: "label", label: "Attribution label", placeholder: "— Founder's Note" },
            { key: "meta", label: "Meta line (small caps)", placeholder: "Est. 1998 · Ludhiana" },
          ],
        },
        {
          key: "story", title: "Our Story", hint: "Editorial 2-column section.",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title_line1", label: "Title — Line 1" },
            { key: "title_accent", label: "Title — accented (red) ending" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
            { key: "chip", label: "Sparkle chip line" },
            { key: "paragraphs", label: "Body paragraphs (in order)", type: "paragraphs" },
            { key: "closing", label: "Closing red callout line", type: "textarea" },
          ],
        },
        {
          key: "capabilities", title: "Manufacturing Capabilities",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
            { key: "banner_overline", label: "Banner image overline" },
            { key: "banner_title", label: "Banner image headline" },
            { key: "banner_image", label: "Banner image URL (optional)" },
          ],
          list: {
            path: "items", label: "Capability cards (4 recommended)",
            defaults: { big: "", label: "", sub: "", icon: "Factory" },
            itemFields: [
              { key: "big", label: "Big number / value", placeholder: "60,000 sq ft" },
              { key: "label", label: "Label", placeholder: "Manufacturing floor" },
              { key: "sub", label: "Sub-text", span: 2 },
              { key: "icon", label: "Icon (Factory, Hammer, Flame, ShieldCheck, Cog, etc.)" },
            ],
          },
        },
        {
          key: "timeline", title: "Timeline / Milestones",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
          ],
          list: {
            path: "items", label: "Milestones (chronological)",
            defaults: { year: "", title: "", body: "" },
            itemFields: [
              { key: "year", label: "Year", placeholder: "2014" },
              { key: "title", label: "Title", placeholder: "IATF certified" },
              { key: "body", label: "Body", type: "textarea", span: 2 },
            ],
          },
        },
        {
          key: "process", title: "Manufacturing Process",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
          ],
          list: {
            path: "items", label: "Process steps (6 recommended)",
            defaults: { num: "", title: "", body: "" },
            itemFields: [
              { key: "num", label: "Step number", placeholder: "01" },
              { key: "title", label: "Title", placeholder: "Material Inspection" },
              { key: "body", label: "Body", type: "textarea", span: 2 },
            ],
          },
        },
        {
          key: "mvv", title: "Mission · Vision · Values",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "mission", label: "Mission paragraph", type: "textarea" },
            { key: "vision", label: "Vision paragraph", type: "textarea" },
            { key: "values", label: "Values paragraph", type: "textarea" },
          ],
        },
        {
          key: "why", title: "Why Durga (Why Choose Us)",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
          ],
          list: {
            path: "items", label: "Reasons (6 recommended)",
            defaults: { icon: "Wrench", title: "", body: "" },
            itemFields: [
              { key: "icon", label: "Icon (Wrench, ShieldCheck, Cog, Globe2, Calendar, Heart)" },
              { key: "title", label: "Title" },
              { key: "body", label: "Body", type: "textarea", span: 2 },
            ],
          },
        },
        {
          key: "regions", title: "Global Footprint",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
            { key: "hq_label", label: "HQ label (e.g. Headquarters)" },
            { key: "hq_title", label: "HQ title", placeholder: "Ludhiana, Punjab — India" },
            { key: "hq_sub", label: "HQ sub-line" },
            { key: "hq_image", label: "HQ image URL (optional)" },
          ],
          list: {
            path: "items", label: "Regions (6 recommended)",
            defaults: { region: "", list: "" },
            itemFields: [
              { key: "region", label: "Region name", placeholder: "Europe" },
              { key: "list", label: "Country list", placeholder: "Germany · UK · Italy" },
            ],
          },
        },
        {
          key: "final_cta", title: "Final CTA",
          fields: [
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
            { key: "bullets", label: "Bullet points", type: "list" },
            { key: "cta_primary_text", label: "Primary CTA Text" },
            { key: "cta_primary_link", label: "Primary CTA Link" },
            { key: "cta_secondary_text", label: "Secondary CTA Text" },
            { key: "cta_secondary_link", label: "Secondary CTA Link" },
          ],
        },
        {
          key: "_root", title: "Display options",
          fields: [
            { key: "pullquote_enabled", label: "Show client pull-quote (uses first active testimonial)", type: "boolean" },
          ],
        },
      ]}
    />
  );
}

export function AdminHomePage() {
  return (
    <PageContentEditor
      pageKey="home_page"
      title="Home Page Content"
      schema={[
        {
          key: "specialty", title: "Specialty Spotlight (Hose Clamp Screws)", hint: "Big featured product showcase right after the hero slider.",
          fields: [
            { key: "enabled", label: "Show this section", type: "boolean" },
            { key: "overline", label: "Overline" },
            { key: "headline", label: "Headline — Line 1" },
            { key: "headline_accent", label: "Headline — Line 2 (red)" },
            { key: "subtitle", label: "Subtitle paragraph", type: "textarea" },
            { key: "image", label: "Showcase image URL", placeholder: "/img/hose-clamp-screws.png or external URL" },
            { key: "badge", label: "Top-left badge label" },
            { key: "footer_label", label: "Image footer label" },
            { key: "footer_chips", label: "Image footer chips (comma list)", type: "list" },
            { key: "cta_primary_text", label: "Primary CTA Text" },
            { key: "cta_primary_link", label: "Primary CTA Link" },
            { key: "cta_secondary_text", label: "Secondary CTA Text" },
            { key: "cta_secondary_link", label: "Secondary CTA Link" },
          ],
          list: {
            path: "stats", label: "Stat rows (4 recommended)",
            defaults: { k: "", v: "" },
            itemFields: [
              { key: "k", label: "Big value", placeholder: "16+" },
              { key: "v", label: "Description", placeholder: "head & thread variants" },
            ],
          },
        },
        {
          key: "process", title: "Process Section (dark)", hint: "Four-step process showcase.",
          fields: [
            { key: "enabled", label: "Show this section", type: "boolean" },
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
          ],
          list: {
            path: "items", label: "Process steps (4 recommended)",
            defaults: { num: "", title: "", body: "" },
            itemFields: [
              { key: "num", label: "Step number", placeholder: "01" },
              { key: "title", label: "Title" },
              { key: "body", label: "Body", type: "textarea", span: 2 },
            ],
          },
        },
        {
          key: "why", title: "Why Durga (light)", hint: "Three USP cards on light background.",
          fields: [
            { key: "enabled", label: "Show this section", type: "boolean" },
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
          ],
          list: {
            path: "items", label: "USP cards (3 recommended)",
            defaults: { icon: "Wrench", title: "", body: "" },
            itemFields: [
              { key: "icon", label: "Icon (Wrench, ShieldCheck, Globe2, Cog, Heart, Hammer, Flame, Factory)" },
              { key: "title", label: "Title" },
              { key: "body", label: "Body", type: "textarea", span: 2 },
            ],
          },
        },
        {
          key: "cta", title: "Bold CTA Banner (red)", hint: "Full-bleed red CTA section near the bottom.",
          fields: [
            { key: "enabled", label: "Show this section", type: "boolean" },
            { key: "overline", label: "Overline" },
            { key: "title", label: "Title" },
            { key: "subtitle", label: "Subtitle", type: "textarea" },
            { key: "cta_primary_text", label: "Primary CTA Text" },
            { key: "cta_primary_link", label: "Primary CTA Link" },
            { key: "cta_secondary_text", label: "Secondary CTA Text" },
            { key: "cta_secondary_link", label: "Secondary CTA Link" },
          ],
        },
      ]}
    />
  );
}
